'use client';

import { useParams } from 'next/navigation';

import TermsLayout from '@/components/terms-layout';

const TermsOfServicePage = () => {
  const params = useParams();
  const name = params?.name ? (params.name as string) : '';
  return (
    <div className="flex h-screen w-full overflow-auto bg-bg-blueGreyDeep">
      <TermsLayout name={name} displayTitle={true} />
    </div>
  );
};

export default TermsOfServicePage;
